import { useQuery } from '@tanstack/react-query';

import { ADMIN_MENU_COUNTERS_QUERY_KEY } from '@/shared/lib/invalidateAdminMenuCounters';

import { getAdminMenuCounters } from '@/entities/admin-menu-counters/api/getAdminMenuCounters';

const REFETCH_INTERVAL_MS = 60_000;

/**
 * Счётчики меню админки с фоновым поллингом: сайдбар не ремаунтится при навигации,
 * без интервала бейдж протухнет. Ошибки намеренно не всплывают тостом —
 * поллинг раз в минуту заспамил бы уведомлениями, бейдж просто не рендерится.
 *
 * refetchOnWindowFocus переопределяет глобальный false из app/di: интервал стоит,
 * пока вкладка неактивна, и без рефетча по фокусу вернувшийся админ до минуты
 * смотрел бы на старое число.
 */
export const useAdminMenuCounters = () => {
  const { data: menuCounters } = useQuery({
    queryKey: ADMIN_MENU_COUNTERS_QUERY_KEY,
    queryFn: getAdminMenuCounters,
    refetchInterval: REFETCH_INTERVAL_MS,
    refetchOnWindowFocus: true
  });

  return { menuCounters };
};
